import { TablePagination, TablePaginationProps } from '@material-ui/core'

import { useStyles } from './styles'

export type PaginationProps = Exclude<
  TablePaginationProps<'div'>,
  'labelDisplayedRows' | 'component' | 'SelectProps'
>

export function Pagination({ ...props }: PaginationProps) {
  const classes = useStyles()

  return (
    <TablePagination
      component='div'
      SelectProps={{
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
          elevation: 0,
          classes: {
            paper: classes.paper,
            list: classes.list,
          },
        },
      }}
      className={classes.root}
      {...props}
      labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
    />
  )
}
